import type { ReactElement } from 'react';

import { CHAT_MESSAGE_STATUS } from '@/utils/constants';

import ClockIcon from '@assets/images/icons/icon-clock.svg?react';
import CheckIcon from '@assets/images/icons/icon-check.svg?react';
import DoubleCheckIcon from '@assets/images/icons/icon-check-double.svg?react';

export const STATUS_ICONS: Record<string | number, ReactElement> = {
	[CHAT_MESSAGE_STATUS.sending]: (
		<ClockIcon title="Enviando" fill="#AEAEBA" height="1em" width="1em" viewBox="0 0 25 25" />
	),
	[CHAT_MESSAGE_STATUS.sent]: (
		<CheckIcon title="Enviada" fill="#AEAEBA" height="1em" width="1em" viewBox="0 0 24 25" />
	),
	[CHAT_MESSAGE_STATUS.received]: (
		<DoubleCheckIcon title="Recebida" fill="#AEAEBA" height="1em" width="1em" viewBox="0 0 24 25" />
	),
	[CHAT_MESSAGE_STATUS.read]: (
		<DoubleCheckIcon title="Lida" fill="#FF0032" height="1em" width="1em" viewBox="0 0 24 25" />
	),
	0: (
		<DoubleCheckIcon title="Lida" fill="#FF0032" height="1em" width="1em" viewBox="0 0 24 25" />
	),
};
